import addGuestDialogTemplate from './AddGuestDialog.html';

/*****************************************************************************
 * Component: addGuestDialog */
/**
 * @ngdoc     component
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.component:addGuestDialog
 * @param  {Object} modalInstance $uibModal instance from $uibModal.open method
 * @param  {Object} resolve       Resolve object passed from $uibModal.open method
 * @description
 * Component to add a guest.
 *****************************************************************************/
export const addGuestDialogComponent = {
  template: addGuestDialogTemplate,
  bindings: { modalInstance: '<', resolve: '<' },
  controller: Controller
}

/*****************************************************************************
 * Service: AddGuestDialog */
/**
 * @ngdoc     service
 * @module    csm.books.eventsAdmin
 * @name      csm.books.eventsAdmin.service:AddGuestDialog
 * @description
 * Dialog to attach a guest to an attendee to an event.
 *****************************************************************************/
/* @ngInject */ export function AddGuestDialogService($q, $uibModal, BusyScreen, Events, Tools) {
  /*****************************************************************************
   * show */
  /**
   * @ngdoc    function
   * @name     show
   * @methodOf csm.books.eventsAdmin.AddGuestDialog
   * @param    attendee  Attendee the guest will belong to.
   * @param    eventID   ID of event
   * @return   {Promise}    Resolves upon close.
   * @description
   *
   *****************************************************************************/
  this.show = function (attendee, eventID) {
    return $uibModal.open({
      animation: false,
      backdrop: 'static',
      component: 'addGuestDialog',
      size: 'md',
      resolve: {
        attendee: function () {
          return attendee;
        },
        eventID: function () {
          return eventID;
        }
      }
    }).result;
  };
}

/*******************************************************************************
 * Controller
 *******************************************************************************/
/* @ngInject */ function Controller($injector) {
  var $ctrl = this;
  $ctrl.addGuest = $injector.invoke(addGuest, null, { $ctrl: $ctrl });
  $ctrl.$onInit = $injector.invoke($onInit, null, { $ctrl: $ctrl });
}

/*******************************************************************************
 * Controller.addGuest */
/**
 * @ngdoc     function
 * @name      csm.books.eventsAdmin.controller:addGuest
 * @methodof  csm.books.eventsAdmin.addGuestDialog
 * @description
 * `Add Guest` button click handler. Saves the guest and closes the dialog.
 *******************************************************************************/
/* @ngInject */ function addGuest($ctrl, Alert, BusyScreen, Events) {
  return function () {
    $ctrl.validators.reset();

    /*------------------*/
    /* Validate fields. */
    /*------------------*/
    if (!$ctrl.validators.validate()) return;

    BusyScreen.promise(
      Events.addGuest($ctrl.attendee.id, $ctrl.guestName).then(function () {
        Alert.success('Guest Added');
        $ctrl.close();
      })
    );
  };
}

/*******************************************************************************
 * Controller.$onInit */
/**
 * @ngdoc     function
 * @name      csm.books.eventsAdmin.controller:$onInit
 * @methodof  csm.books.eventsAdmin.addGuestDialog
 * @description
 * Called by angular when the component is ready. This will set up some
 * properties from the bound values.
 *******************************************************************************/
/* @ngInject */ function $onInit($ctrl, Alert) {
  return function () {
    /** Attendee ID. */ $ctrl.attendee = $ctrl.resolve.attendee;
    /** Event ID.    */ $ctrl.eventID = $ctrl.resolve.eventID;
    /** Validators   */ $ctrl.validators = {};

    /*------------------------*/
    /* Available guest types. */
    /*------------------------*/
    //    $ctrl.types = [ { name: "Student",     isStudent: true  },
    //                    { name: "Non Student", isStudent: false } ];

    /*-----------------------------*/
    /* Attendee Name & Student ID. */
    /*-----------------------------*/
    $ctrl.attendeeName =
      $ctrl.attendee.lastName +
      ', ' +
      $ctrl.attendee.firstName +
      ' (' +
      $ctrl.attendee.studentID +
      ')';

    /*-----------------------------------------------------------*/
    /* Create references to the modal dismiss and close methods. */
    /*-----------------------------------------------------------*/
    $ctrl.dismiss = $ctrl.modalInstance.dismiss;
    $ctrl.close = $ctrl.modalInstance.close;
  };
}
